export default __webpack_public_path__ + "static/media/swiftstrikes6.9d2185a9.png";